import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _DISCLOSURETYPE_STRON;

import { DISCLOSURE_TYPES } from '../../constants/deal/fnis.constants';
import { uuid } from './index';
export function generateColumnId(paymentOption) {
  var paymentType = paymentOption.paymentType,
      value = paymentOption.value;
  var randomId = uuid();
  return "".concat(paymentType).concat(value, "_").concat(randomId);
}
export var DISCLOSURETYPE_STRONG_TYPE_MAP = (_DISCLOSURETYPE_STRON = {}, _defineProperty(_DISCLOSURETYPE_STRON, DISCLOSURE_TYPES.DEBT_CANCELLATION_AGGREEMENT, 2), _defineProperty(_DISCLOSURETYPE_STRON, DISCLOSURE_TYPES.INSURANCE, 2), _DISCLOSURETYPE_STRON); // https://tekion.atlassian.net/browse/DMS-11446

/**
      taxable, upfront, taxableInCap
      Taxable:
      //loan taxable
      //lease
        capped: taxableInCap
        upfront: taxable
*/

export var getTaxableFlagForCustomFeeForLease = function getTaxableFlagForCustomFeeForLease(taxable, upfront, explicitelyTaxCappedCustomFeeInLease) {
  return upfront ? taxable : explicitelyTaxCappedCustomFeeInLease && taxable;
};